"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/KeywordsTab/KeywordForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _keywords = require('shared/validation/team/keywords');

var _Form = require('web/components/Form');

const NEW_KEYWORD = { Keyword: '', Phrase: '', Reply: '', Flags: true }

// The message a server refusal carries (wsCommand rejects with { Error }).
 const serverMessage = (err) => {
  const message = _optionalChain([(err ), 'optionalAccess', _ => _.Error])
  return typeof message === 'string' ? message : ''
}; exports.serverMessage = serverMessage
















const FieldError = ({ id, message }) => message
  ? _react2.default.createElement('div', { id: id, className: "team-page--keywords--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}},  message )
  : null

const KeywordForm = ({
  keyword, others, onSave, onCancel, onDelete, onDraft,
}) => {
  const id = _react.useId.call(void 0, )
  const [draft, setDraft] = _react.useState(_nullishCoalesce(keyword, () => ( NEW_KEYWORD)))
  const [touched, setTouched] = _react.useState({})
  const [isSubmitted, setIsSubmitted] = _react.useState.call(void 0, false)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [serverError, setServerError] = _react.useState.call(void 0, '')
  const [isPhraseFocused, setIsPhraseFocused] = _react.useState.call(void 0, false)

  const word = _keywords.normalizeKeyword.call(void 0, draft.Keyword)
  _react.useEffect.call(void 0, () => onDraft(draft, isPhraseFocused), [draft, isPhraseFocused, onDraft])
  const errors = _keywords.validateKeyword.call(void 0, draft, others)
  const shown = (f) => (isSubmitted || touched[f]) ? errors[f] : undefined

  const change = (f) =>
    (e) => {
      setDraft(d => ({ ...d, [f]: e.target.value }))
      setTouched(t => ({ ...t, [f]: true }))
      setServerError('')
    }

  const submit = (e) => {
    e.preventDefault()
    setIsSubmitted(true)
    if (Object.keys(errors).length) return
    setIsSaving(true)
    setServerError('')
    onSave({
      Keyword: _keywords.normalizeKeyword.call(void 0, draft.Keyword),
      Phrase: draft.Phrase.trim(),
      Reply: draft.Reply.trim(),
      Flags: draft.Flags,
    })
      .catch((err) => {
        setServerError(exports.serverMessage.call(void 0, err))
      })
      .finally(() => setIsSaving(false))
  }

  return (
    _react2.default.createElement('form', {
      className: "team-page--keywords--form",
      'aria-label': keyword ? 'Edit keyword' : 'Add keyword',
      onSubmit: submit,
      noValidate: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}

      , _react2.default.createElement('div', { className: "team-page--keywords--form-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}},  keyword ? `Edit ${keyword.Keyword}` : 'New keyword' )
        , _react2.default.createElement('div', { className: "team-page--keywords--form-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
          , _react2.default.createElement('label', { className: "team-page--keywords--label", htmlFor: `${id}-keyword`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Keyword")
          , _react2.default.createElement(_Form.TextInput, {
            id: `${id}-keyword`,
            className: "team-page--keywords--keyword-input",
            wrapperClassName: "team-page--keywords--keyword-field",
            value: draft.Keyword,
            onChange: change('Keyword'),
            hasError: !!shown('Keyword'),
            'aria-describedby': shown('Keyword') ? `${id}-keyword-error` : undefined,
            autoFocus: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
          )
          , _react2.default.createElement(FieldError, { id: `${id}-keyword-error`, message: shown('Keyword'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}} )

          , _react2.default.createElement('label', { className: "team-page--keywords--label", htmlFor: `${id}-phrase`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, "Reply "
             ,  word || 'KEYWORD' , " …"
          )
          , _react2.default.createElement(_Form.TextInput, {
            id: `${id}-phrase`,
            value: draft.Phrase,
            onChange: change('Phrase'),
            onFocus: () => setIsPhraseFocused(true),
            onBlur: () => setIsPhraseFocused(false),
            hasError: !!shown('Phrase'),
            'aria-describedby': shown('Phrase') ? `${id}-phrase-error` : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
          )
          , _react2.default.createElement(FieldError, { id: `${id}-phrase-error`, message: shown('Phrase'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}} )

          , _react2.default.createElement('label', { className: "team-page--keywords--label", htmlFor: `${id}-reply`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}, "Reply")
          , _react2.default.createElement('textarea', {
            id: `${id}-reply`,
            className: `blm-text-input team-page--keywords--reply-input${shown('Reply') ? ' blm-text-input--has-error' : ''}`,
            value: draft.Reply,
            onChange: change('Reply'),
            'aria-invalid': !!shown('Reply'),
            'aria-describedby': shown('Reply') ? `${id}-reply-error` : undefined,
            rows: 3, __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
          )
          , _react2.default.createElement('div', { className: "team-page--keywords--help team-page--keywords--help--row" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
            , _react2.default.createElement(FieldError, { id: `${id}-reply-error`, message: shown('Reply'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 128}},  draft.Reply.length , " / "  ,  _keywords.MAX_REPLY_LENGTH )
          )

          , _react2.default.createElement('div', { className: "team-page--keywords--form-flags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
            , _react2.default.createElement(_Form.Toggle, {
              isChecked: draft.Flags,
              onChange: Flags => setDraft(d => ({ ...d, Flags })),
              label: "Flags the chat"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
            )
            ,  draft.Flags && (
              _react2.default.createElement('span', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
                , _react2.default.createElement('span', { className: "team-page--keywords--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}, "↰ " ,  word || 'KEYWORD' ), " in Requests"
              )
            )
          )
          ,  serverError && _react2.default.createElement('div', { className: "team-page--keywords--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}},  serverError ) 
          , _react2.default.createElement('div', { className: "team-page--keywords--form-buttons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
            , _react2.default.createElement(_Form.Button, { isSubmit: true, isLoading: isSaving, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}, "Save")
            , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onCancel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}, "Cancel")
            ,  onDelete && (
              _react2.default.createElement('button', { type: "button", className: "team-page--keywords--delete-btn", onClick: onDelete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}, "Delete"

              )
            )
          )
        )
    )
  )
}

exports. default = KeywordForm
